import { Button, Checkbox, Input } from "antd";
import { useEffect, useState } from "react";
import SearchIcon from "../../../assets/icons/SearchIcon";
import Avatar from "../../../assets/images/avatar.svg";
import {
  useGetFilterGroupUserQuery,
  useUpdateGroupMemberMutation,
} from "../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";

type AddNewMemberModalProps = ModalComponentProps & {
  handleParentClose?: () => void;
  chatId?: number;
};

export default function AddNewMemberModal({
  handleClose,
  handleParentClose,
  chatId,
  ...rest
}: AddNewMemberModalProps) {
  const [search, setSearch] = useState("");

  // const [selectedDepartmentId, setSelectedDepartmentId] = useState<
  //   number | null
  // >(null);
  // const [selectedSubDepartmentId, setSelectedSubDepartmentId] = useState<
  //   number | null
  // >(null);
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);

  // const auth = useAppSelector((state) => state.auth);

  // const {
  //   isError: allDepartmentIsError,
  //   error: allDepartmentError,
  //   data: allDepartmentData,
  // } = useGetAllDepartmentQuery({
  //   params: {
  //     page: 1,
  //     limit: 100000000,
  //   },
  // });

  // const id = selectedDepartmentId ? selectedDepartmentId : skipToken;

  // const {
  //   isError: subDepartmentIsError,
  //   error: subDepartmentError,
  //   data: subDepartmentData,
  // } = useGetSubDepartmentByIdGroupChatQuery(id);

  // const {
  //   isError: getChatUserListIsError,
  //   error: getChatUserListError,
  //   data: getChatUserListData,
  // } = useGetChatUserListQuery({
  //   params: {
  //     search,
  //     department_id: selectedDepartmentId ?? undefined,
  //     sub_department_id: selectedSubDepartmentId ?? undefined,
  //   },
  // });

  const {
    isError: isGetFilterGroupUserError,
    error: getFilterGroupUserError,
    data: getFilterGroupUserData,
  } = useGetFilterGroupUserQuery({
    id: chatId,
    params: {
      search,
    },
  });

  const [
    updateGroupMember,
    {
      isError: updateGroupMemberIsError,
      error: updateGroupMemberError,
      isSuccess: updateGroupMemberIsSuccess,
      isLoading: updateGroupMemberIsLoading,
    },
  ] = useUpdateGroupMemberMutation();

  useError(
    isGetFilterGroupUserError,
    getFilterGroupUserError,
    "Get user filter list fail"
  );
  // useError(
  //   allDepartmentIsError,
  //   allDepartmentError,
  //   "Get all department list fail"
  // );
  // useError(
  //   subDepartmentIsError,
  //   subDepartmentError,
  //   "Get sub department list fail"
  // );
  // useError(
  //   getChatUserListIsError,
  //   getChatUserListError,
  //   "Get chat user list fail"
  // );
  useError(
    updateGroupMemberIsError,
    updateGroupMemberError,
    "Group member add fail"
  );

  const handleUserToggle = (id: number) => {
    setSelectedUserIds((prev) =>
      prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    const allIds =
      getFilterGroupUserData?.data?.map((user: any) => user.id) || [];
    if (selectedUserIds.length === allIds.length) {
      setSelectedUserIds([]);
    } else {
      setSelectedUserIds(allIds);
    }
  };

  const handleGroupMemberAdd = () => {
    let hasError = false;

    if (selectedUserIds.length === 0) {
      toast("warning", "Please select at least one user to create the group.");
      hasError = true;
    }

    if (hasError) return;

    const newData = {
      user_ids: selectedUserIds,
    };

    updateGroupMember({
      id: chatId,
      data: newData,
    });
  };

  useEffect(() => {
    if (updateGroupMemberIsSuccess) {
      toast("success", "Group member added successfully!");
      setSearch("");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateGroupMemberIsSuccess]);

  return (
    <CustomModal
      title="Select add new member"
      {...rest}
      handleClose={handleClose}
      width={360}
      footer={null}
    >
      <div>
        <Input
          prefix={<SearchIcon />}
          placeholder="Search"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          allowClear
        />
        {/* <div className="mt-3 flex gap-3">
          <Select
            showSearch
            placeholder="Department"
            optionFilterProp="label"
            options={allDepartmentData?.data.map((dep: any) => ({
              label: dep.name,
              value: dep.id,
            }))}
            onChange={(value) => setSelectedDepartmentId(value)}
            allowClear
            className="flex-1"
            value={selectedDepartmentId}
          />
          <Select
            showSearch
            placeholder="Sub-Department"
            optionFilterProp="label"
            options={subDepartmentData?.data.map((dep: any) => ({
              label: dep.name,
              value: dep.id,
            }))}
            onChange={(value) => setSelectedSubDepartmentId(value)}
            allowClear
            className="flex-1"
            value={selectedSubDepartmentId}
            disabled={!selectedDepartmentId}
          />
        </div> */}

        <div>
          <div className="flex justify-between items-center mt-2 py-2">
            <span>Select all</span>
            <span>
              <Checkbox
                checked={
                  (getFilterGroupUserData?.data?.length || 0) > 0 &&
                  selectedUserIds.length ===
                    (getFilterGroupUserData?.data?.length || 0)
                }
                indeterminate={
                  selectedUserIds.length > 0 &&
                  selectedUserIds.length <
                    (getFilterGroupUserData?.data?.length || 0)
                }
                onChange={handleSelectAll}
              />
            </span>
          </div>
          <div className="max-h-[300px] overflow-auto pr-2">
            {getFilterGroupUserData?.data?.map((user: any) => (
              <div
                key={user?.id}
                className="flex items-center justify-between mb-2"
              >
                <div className="flex gap-4 items-center">
                  <div>
                    <img
                      className="w-10 h-10 rounded-full object-cover"
                      src={user?.personalInfo?.pro_pic || Avatar}
                      alt={user?.personalInfo?.name}
                    />
                  </div>
                  <div className="text-[17px]">{user?.personalInfo?.name}</div>
                </div>
                <div>
                  <Checkbox
                    checked={selectedUserIds.includes(user.id)}
                    onChange={() => handleUserToggle(user.id)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="py-2 flex justify-between">
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            loading={updateGroupMemberIsLoading}
            onClick={handleGroupMemberAdd}
            disabled={selectedUserIds.length === 0}
            className="bg-[#FFF1EB] text-[#FE7235] border-none"
          >
            Add
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
